import assign from 'lodash/assign';
import isEmpty from 'lodash/isEmpty';
import { CreditCardUtilitiesServiceModule } from 'services/utilities/creditCardUtilities.service';
import { PaymentMethodServiceModule } from 'services/payment/paymentMethod/paymentMethod.service';
import { AddressUtilitiesServiceModule } from 'services/utilities/addressUtilities.service';
import { CardInfoModule } from 'components/creditCards/cardInfo/cardInfo';
import { UpdatePaymentButtonComponent } from '../updatePaymentButton/updatePaymentButton.component';

import template from './updatePaymentCard.html';
import './updatePaymentCard.scss';

export const UpdatePaymentCardModule = angular
    .module('app.components.updatePayment.updatePaymentCard', [
        CreditCardUtilitiesServiceModule,
        PaymentMethodServiceModule,
        AddressUtilitiesServiceModule,
        UpdatePaymentButtonComponent,
        CardInfoModule
    ]).component('updatePaymentCard', {
        template,
        bindings: {
            titleText: '@',
            updatedPaymentCard: '<'
        },
        controller: class UpdatePaymentCardController {
            constructor(
                $scope,
                creditCardUtilities,
                addressUtilities,
                paymentMethodService
            ) {
                'ngInject';

                assign(this, {
                    $scope,
                    creditCardUtilities,
                    addressUtilities,
                    paymentMethodService,
                    paymentMethod: {},
                    loading: true,
                    hasPaymentMethod: false
                });
            }

            $onInit() {
                this.paymentMethodService.getPaymentMethod().then((paymentMethod) => {
                    this.hasPaymentMethod = !isEmpty(paymentMethod.creditCard);
                    if (this.hasPaymentMethod) this.setPaymentInfo(this.convertStipeInfo(paymentMethod.creditCard));
                    this.loading = false;
                });
            }

            $onChanges(changesObj) {
                if (changesObj.updatedPaymentCard &&
                    changesObj.updatedPaymentCard.currentValue !== changesObj.updatedPaymentCard.previousValue) {
                    this.setPaymentInfo(changesObj.updatedPaymentCard.currentValue);
                }
            }

            convertStipeInfo(stripeInfo) {
                stripeInfo.address = this.addressUtilities.convertStripeAddress(stripeInfo.address);
                stripeInfo.expirationString = `${stripeInfo.expiration.month}/${stripeInfo.expiration.year}`;
                stripeInfo.maskedCardNumber = this.creditCardUtilities.getMaskedCardNumber(stripeInfo.lastFour);
                return stripeInfo;
            }

            setPaymentInfo(paymentInfo) {
                this.paymentMethod = paymentInfo;
            }

            paymentMethodChanged(cardInfo) {
                this.setPaymentInfo(cardInfo);
            }
        }
    }).name;


// WEBPACK FOOTER //
// ./src/app/components/updatePayment/updatePaymentCard/updatePaymentCard.component.js